import 'dayjs/locale/ru';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';

dayjs.locale('ru');
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

const formatDate = ({ date, format, preset, utc, tz }) => {
    const newDate = new Date(date);
    const finalFormat =
        format ||
        {
            success: 'D MMMM YYYY HH:mm',
            pretty: 'D MMMM YYYY',
            local: 'YYYY-MM-DD, HH:mm:ss',
            day: 'D',
            weekday: 'dd',
            mounth: 'MMM',
            origin: 'YYYY-MM-DD',
        }[preset];

    const utcDate = utc && !tz ? dayjs(newDate).utc() : dayjs(newDate);

    const finalDate = tz ? dayjs(newDate).tz(tz) : utcDate;

    return finalDate.format(finalFormat);
};

export default formatDate;
